/**
 * Credentials Service
 *
 * Handles YouTube OAuth credential operations via API Gateway REST API.
 * Uses AuthenticatedApiClient for consistent auth handling including
 * 401 silent-refresh retry.
 *
 * Requirements: 9.1, 9.2, 9.3, 9.4
 */

import { AuthenticatedApiClient } from './authenticated-api-client';
import type { CredentialStatus } from '../types';

export class CredentialsService {
    private client: AuthenticatedApiClient;

    constructor() {
        this.client = new AuthenticatedApiClient();
    }

    async getCredentialStatus(): Promise<CredentialStatus> {
        const response = await this.client.apiRequest('/settings/youtube-credentials', { method: 'GET' });
        return response.json();
    }

    async saveCredentials(clientId?: string, clientSecret?: string): Promise<CredentialStatus> {
        const body: Record<string, string> = {};
        if (clientId !== undefined) {
            body.client_id = clientId;
        }
        if (clientSecret !== undefined) {
            body.client_secret = clientSecret;
        }

        const response = await this.client.apiRequest('/settings/youtube-credentials', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        return response.json();
    }
}
